import DIALOG from '../../../../DOM/dialog/DIALOG.js';
import { text } from '../../../../DOM/text/TEXT.js';
import { makeAttrStruct } from '../../../../../enums/ModelAttr.js';
import { makeStruct } from '../../../../../enums/MODELS.js';
import { makeDataStruct } from '../../../../../enums/ModelData.js';
import BUTTONGROUP, { buttongroup } from '../../../../DOM/GROUP/buttongroup/BUTTONGROUP.js';
import { button } from '../../../../DOM/button/BUTTON.js';
import { span } from '../../../../DOM/span/SPAN.js';
import { SVGS } from '../../../../SVG/SVGS.js';
import { icon } from '../../../../SVG/icon/ICON.js';
import { navheader } from '../../../../DOM/nav/navbar/navheader/NAVHEADER.js';
// Model Structure
export const userOptionsDialogAttr = makeAttrStruct([
    ['open'],
    ['closeOnFocusOut', true]
]);
export const userOptionsDialogData = makeDataStruct([
    ['caller', null],
    ['loader'],
    ['header', navheader('UserOptions')],
    ['footer', {}],
    ['text', text('User Options')],
    ['onConfirm', () => { }],
    ['onCancel', () => { }]
]);
export const userOptionsDialogModel = makeStruct([
    ['attributes', userOptionsDialogAttr],
    ['data', userOptionsDialogData]
]);
// Simplified Model
export function userOptionsDialog(caller, loader, text, header, footer) {
    return {
        attributes: userOptionsDialogAttr(),
        data: userOptionsDialogData(caller, loader, header, footer, text)
    };
}
/** A DIALOG with an embedded FORM that can be used to recieve input
    @description Creates a dialog and displays a text well and any included buttons
*/
export default class USEROPTIONS extends DIALOG {
    constructor(node, model) {
        super(node, model);
        this.addClass('useroptions');
        this.caller.on('deactivate', () => this.closeDialog());
        let buttonGroup = new BUTTONGROUP(this.content, buttongroup('user-options-buttons', 'vertical has-background'));
        buttonGroup.addButton(button(span('Profile Settings', 'btn-profile'), 'btn-profile', icon(SVGS.USER), 'Edit your profile settings'))
            .on('click', () => {
            console.log('Profile Settings clicked');
        });
        buttonGroup.addButton(button(span('Change Password', 'btn-password'), 'btn-password', icon(SVGS.GEAR), 'Change your password'))
            .on('click', () => {
            console.log('Change Password clicked');
        });
        buttonGroup.addButton(button(span('Notification Settings', 'btn-notifications'), 'btn-notifications', icon(SVGS.GEAR), 'Manage notification preferences'))
            .on('click', () => {
            console.log('Notification Settings clicked');
        });
        buttonGroup.addButton(button(span('Logout', 'btn-logout'), 'btn-logout', icon(SVGS.USER), 'Log out and end session'))
            .on('activate', () => {
            ['token', 'refreshToken', 'userId', 'username', 'email', 'roles'].forEach((key) => window.sessionStorage.removeItem(key));
            location.reload();
        });
    }
}
